module.exports = __webpack_public_path__ + "img/pr-2.5025e99f.png";